import * as React from 'react';

import enterpriseAdminUser from 'bundles/enterprise-admin';
import ContinueProgramSetUpBanner from 'bundles/enterprise-admin-coursera-for-campus-basic/components/ContinueProgramSetUpBanner';
import GoogleContinueProgramSetupBanner from 'bundles/enterprise-admin-grow-with-google/components/GoogleContinueProgramSetupBanner';
import type { GetAllProgramDraftStatusesQuery_EnterpriseProgramDraftsV1Resource_multiGet_elements as ProgramsAndDraftStatuses } from 'bundles/enterprise-admin-grow-with-google/utils/__generated__/GetAllProgramDraftStatusesQuery';
import EnterprisePermissionsRequired from 'bundles/enterprise-admin-roles/components/EnterprisePermissionsRequired';
import {
  ENTERPRISE_ADMIN_PERMISSION_SUBDOMAIN,
  ENTERPRISE_ADMIN_PERMISSION_VERB,
} from 'bundles/enterprise-admin-roles/types';
import type EnterpriseProgramsV1 from 'bundles/naptimejs/resources/enterprisePrograms.v1';

type Props = {
  programId?: string;
  programSlug?: string;
  orgId: string;
  orgSlug: string;
  allPrograms: EnterpriseProgramsV1[];
  hasGwGInvitees: boolean;
  gwgProgramsWithoutInvitees?: Array<ProgramsAndDraftStatuses>;
};

const OrgBannerFactory = ({
  allPrograms,
  gwgProgramsWithoutInvitees,
  hasGwGInvitees,
  orgSlug,
  programId,
  programSlug,
}: Props) => {
  const firstGwGProgramWithoutInvitees = allPrograms.filter(
    (program) => gwgProgramsWithoutInvitees?.[0]?.id === program?.id
  )[0];

  if (!programId || !programSlug) {
    return null;
  } else if (
    programId &&
    (enterpriseAdminUser.isC4CBOrg ||
      (enterpriseAdminUser.isGwGFreemiumOrg && (hasGwGInvitees || !firstGwGProgramWithoutInvitees)))
  ) {
    return (
      <EnterprisePermissionsRequired
        domain="PROGRAM"
        domainId={programId}
        subdomain={ENTERPRISE_ADMIN_PERMISSION_SUBDOMAIN.CURRICULUM}
        verb={ENTERPRISE_ADMIN_PERMISSION_VERB.EDIT}
      >
        <ContinueProgramSetUpBanner
          orgSlug={orgSlug}
          programSlug={programSlug}
          programId={programId}
          numOfPrograms={allPrograms.length}
        />
      </EnterprisePermissionsRequired>
    );
  } else if (enterpriseAdminUser.isGwGOrg || enterpriseAdminUser.isGwGFreemiumOrg) {
    return (
      <EnterprisePermissionsRequired
        domain="PROGRAM"
        domainId={enterpriseAdminUser.isGwGFreemiumOrg ? firstGwGProgramWithoutInvitees.id : programId}
        subdomain={ENTERPRISE_ADMIN_PERMISSION_SUBDOMAIN.CURRICULUM}
        verb={ENTERPRISE_ADMIN_PERMISSION_VERB.EDIT}
      >
        <GoogleContinueProgramSetupBanner
          orgSlug={orgSlug}
          programSlug={
            enterpriseAdminUser.isGwGFreemiumOrg ? firstGwGProgramWithoutInvitees.metadata.slug : programSlug
          }
          programId={enterpriseAdminUser.isGwGFreemiumOrg ? firstGwGProgramWithoutInvitees.id : programId}
          numOfPrograms={allPrograms.length}
          isGwGFreemiumMerged={enterpriseAdminUser.isGwGFreemiumOrg}
        />
      </EnterprisePermissionsRequired>
    );
  } else {
    return null;
  }
};

export default OrgBannerFactory;
